import React, { RefObject } from 'react';
import useSearchResultTable from 'hooks/search/useSearchResultTable';

import styled from 'styled-components';
import { ISearchDB } from 'type/db';

interface ISearchResultItem {
	data: ISearchDB;
	before_analysis?: boolean;
	_onClick: () => void;
	_ref?: RefObject<HTMLLIElement>;
}

const SearchResultItem = ({
	data,
	before_analysis,
	_ref,
	_onClick,
}: ISearchResultItem) => {
	const [search_header, search_cell] = useSearchResultTable();

	return (
		<Row before_analysis={before_analysis} ref={_ref} onClick={() => _onClick()}>
			{Object.keys(search_header).map((item, idx) => (
				<React.Fragment key={idx}>{search_cell[item](data)}</React.Fragment>
			))}
		</Row>
	);
};

export const Row = styled.li<{ before_analysis?: boolean }>`
	width: 100%;
	height: 65px;
	padding: 8px 32px;
	border-radius: 8px;

	background-color: ${({ theme }) => theme.colors.gray.gray_white};
	&:hover {
		background-color: ${({ theme }) => theme.colors.gray.gray10};
	}

	${({ theme }) => theme.common.flexStart};

	transition: 0.2s background-color;
	cursor: pointer;
`;
export default SearchResultItem;
